import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../components/Buttons";

export const Owners = () => {
    document.title = "İsitfadəçilər";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "İsitfadəçilər", value: "/settings/owners", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">İsitfadəçilər</h2>
                    <p>
                        Sistemdən istifadə edəcək şəxslər üçün nəzərdə tutulub. Sahibkarın əməkdaşlarını, anbardarlar, dükandakı satıcılar, səyyar çalışan
                        ekspediterləri qeyd etmək üçündür
                        <br />
                        Ayarlar səhifəsində <mark>İsitfadəçilər</mark> seçimi edildikdən sonra açılan pəncərədə <NewButton>İstifadəçi</NewButton> düyməsi ilə
                        yaradılacaq yeni istifadəçinin adını, parolunu təyin edib <SaveButton /> düyməsini sıxmaq lazımdır.
                        <br />
                        <b>Qeyd</b>: Yeni istifadəçi sistemə əlavə olunduqda mütləq Ayarlar ⮞ Tariflər səhifəsindən artırılan istifadəçi sayı nəzərə alınmalı və{" "}
                        <div class="form-check form-switch m-0">
                            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked />
                            <label class="form-check-label" for="flexSwitchCheckChecked">
                                aktiv status seçimi edilməlidir. Əks halda yeni istifadəçi, öz login parolu ilə sistemə daxil ola bilməyəcək
                            </label>
                        </div>
                        <br />
                        Nümunədə yeni istifadəçi yaratmaq ardıcıllığı göstərilib.
                    </p>
                    <img src="/images/settings/owners-1.gif" alt="İsitfadəçilər" />

                    <h2 className="my-4">İsitfadəçi icazələri</h2>
                    <p>
                        Sahibkar, sistemdən istifadə edəcək istifadəçilərə icazələr təyin etməlidir
                        <br />
                        Yeni yaradılan istifadəçinin icazələrini təyin etmək üçün düyməsini sıxıb, açılan pəncərədə istifadəçinin vəzifəsini müəyyənləşdirmək və{" "}
                        <SaveButton /> düyməsini sıxmaq lazımdır
                        <br />
                        <b>Qeyd</b>: istifadəçinin icazələri təyin edilərkən, fəlaliyyət göstərəcəkləri satış nöqtəsi və ya anbar seçimi mütləq edilməlidir
                        <br />
                        Nümunədə yeni istifadəçinin icazələrini təyin etmək qaydası göstərilib.
                    </p>
                    <img src="/images/settings/owners-2.gif" alt="İsitfadəçilər" />
                </article>
            </div>
        </div>
    );
};
